import { setRefundStepOne } from 'store/reservations/actions';

const schema = {};

export const config = ({ folio = '' }) => ({
  schema,
  textBold: folio,
  messageBold: true,
  modalType: 'empty',
  initialTouched: {},
  initialValues: {},
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: true,
  showCancel: false,
  withButtons: false,
  submitForm: setRefundStepOne,
  btnSubmitLabel: 'Devolución',
  dialogs: {
    confirmation: {
      title: 'VERIFICAR DEVOLUCIÓN',
      message: `Debes verificar la devolución del vehículo`,
      actionLabel: 'Continuar',
      cancelLabel: 'Cancelar',
    },
    response: {
      successTitle: 'Procesando devolución...',
      errorTitle: '¡UPS! ALGO PASÓ!',
      successMessage: `No cierre, ni actualice el navegador.`,
      errorMessage:
        'Hubo un error mientras procesabamos la información, por favor intenta de nuevo.',
      successLabel: 'Ir a reservaciones',
      errorLabel: 'Reintentar',
      cancelLabel: 'Cancelar',
      successPath: '/daily-rent-contracts/',
    },
  },
});
